import { render } from "./HeaderCanvas.vue?vue&type=template&id=d4aebdb4"
import script from "./HeaderCanvas.vue?vue&type=script&lang=js"
export * from "./HeaderCanvas.vue?vue&type=script&lang=js"

import "./HeaderCanvas.vue?vue&type=style&index=0&id=d4aebdb4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__